import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';

@Injectable({
  providedIn: 'root'
})
export class MasterCountCategoryService {
  public endpoint: string = `${environment.apiUrl}/master`;
  public categoriesData$: State<any>;
  public categories$: Observable<any>;

  constructor(
    private _http: HttpClient
  ) { 
    this.categoriesData$ = new State([]);
    this.categories$ = select$(this.categoriesData$, data => data);
  }

  onCreateCategory(form){
    return this._http.post(`${this.endpoint}/category`, {
      form
    }).pipe(first()).subscribe(res => {
      const data = [res, ...this.categoriesData$.getValue()];
      this.categoriesData$.next(data);
    });
  }

  onDeleteCategory(id){
    return this._http.delete(`${this.endpoint}/category/${id}`).pipe(first()).subscribe(res => {
      const data = this.categoriesData$.getValue().filter(item => item.pmccID !== id);
      this.categoriesData$.next(data);
    });
  }

  onEditCategory(form, cat){
    return this._http.patch(`${this.endpoint}/category/${cat.pmccID}`, {
      pmccNameEn: form.pmccNameEn
    }).pipe(first()).subscribe((area:any)=> {
      let arr;
      this.categoriesData$.pipe(first()).subscribe(res => arr = res);
      const updated = arr.map(item => {
        if(item.pmccID === cat.pmccID){
          item['pmccNameEn'] = form.pmccNameEn;
        }

        return item;
      });
      this.categoriesData$.next(updated);
    });
  }

  onGetCategories(){
    this._http.get(`${this.endpoint}/category`).pipe(first()).subscribe(res => {
      let data;
      this.categories$.pipe(first()).subscribe(res => data = res);
      this.categoriesData$.next(res);
    });
  }
}
